import { useBrandDetails } from 'dw-au-react-components';
import React, { useContext } from 'react';
import { Content } from '../Components/Content/index';
import { Error } from '../Components/Error';
import { ShoppingCart } from '../Components/ShoppingCart';
import { ContentfulContext } from '../Context/Contentful';

function Home() {
	const { entries, products } = useContext(ContentfulContext);

	const brandData = useBrandDetails();

	return (
		<>
			{entries &&
				(entries?.items[0]?.fields.brand.indexOf(brandData.tag) > -1 ? (
					// &&
					// products &&
					// products.length > 0
					<div
						className={`main__content ${brandData.tag} promoCode__${entries?.items[0]?.fields?.slug}`}
					>
						<Content entries={entries} brandData={brandData} />
						{products && products.length > 0 && (
							<ShoppingCart entries={entries} />
						)}
					</div>
				) : (
					<Error errorMessage={entries?.items[0]?.fields.errorMessage} />
				))}
		</>
	);
}

export default Home;
